<section *ngIf="identity && !preload && topbanners && topbanners.length > 0" class="custom-banner-section">
  <div class="custom-banner-carousel owl-carousel" id="banner-carousel">
    <div class="custom-banner-slide" *ngFor="let topbanner of topbanners">
      <div class="custom-banner-image">
        <img [src]="validateImageUrl(topbanner.tagImg)" alt="Banner promocional">
      </div>
      <div class="custom-banner-content">
        <div class="banner-text-container">
          <h2 class="banner-title">{{topbanner.tagH3}}</h2>
          <p class="banner-description">{{topbanner.tagP1}}</p>
          <h4 class="banner-subtitle">{{topbanner.tagH4}}</h4>
          
          <div class="banner-highlight">
            <p>{{topbanner.tagP2}} <span>{{topbanner.tagSpan}}</span></p>
          </div>
          
          <div class="banner-action">
            <a *ngIf="topbanner.productId" class="banner-button" 
               [routerLink]="['/product/', topbanner.productId]">
              {{topbanner.tagButton}}
            </a>
            <a *ngIf="topbanner.url" class="banner-button" 
               href="{{topbanner.url}}" target="_blank">
              {{topbanner.tagButton}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section *ngIf="identity && preload" class="d-flex justify-content-center">
  <div class="spinner-border text-muted my-3"></div>
</section>